import { Routes } from '@angular/router';

export const authRoutes: Routes = [
  { path: 'login', loadComponent: () => import('./login/login.component').then(m => m.LoginComponent), data: { hideNavbar: true } },
  { path: 'register', loadComponent: () => import('./register/register.component').then(m => m.RegisterComponent), data: { hideNavbar: true } },
  { path: 'reset-password/:resetUid', loadComponent: () => import('./reset-password/reset-password.component').then(m => m.ResetPasswordComponent), data: { hideNavbar: true } },
  { path: '', redirectTo: 'login', pathMatch: 'full' }
];
